import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Table, Button, Col, Label, FormGroup, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { dispatchErrorMessage } from '../../../../../actions';
import { AvFeedback, AvGroup, AvInput } from 'availity-reactstrap-validation';
import moment from 'moment';
import { prependTimeWithZero } from '../../../../../utils/CommonUtils';

class ProductDayAvailabilityScreen extends Component {
    constructor() {
        super();

        this.state = {
            currentDayAvailability: {
                id: -1,
                startHour: null,
                startMinute: null,
                endHour: null,
                endMinute: null,
                startDate: ''
            },
            isDaysChanged: false
        }

        this.changeState = this.changeState.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    componentDidUpdate(prevProps) {

    }

    changeState = ({ target }) => {
        let targetValue = target.value;
        if (target.type === 'date') {
            targetValue = target.value.split(/\D/);
            targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
            targetValue = moment(targetValue).format("DD-MM-YYYY")

            this.setState({
                currentDayAvailability: {
                    ...this.state.currentDayAvailability,
                    startDate: targetValue
                }
            })
        } else {
            this.setState({
                currentDayAvailability: {
                    ...this.state.currentDayAvailability,
                    [target.name]: parseInt(targetValue)
                }
            })
        }
    }

    getValue(value) {
        if (value === 0) {
            return '00';
        }

        return value || '';
    }

    validateHoursValues(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }

            if ((e.target.name == 'startHour' || e.target.name == 'endHour') && inputKeyCode > 51 && inputKeyCode < 48) {
                e.preventDefault();
            }
        }
    }

    validateMinutesValues(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }
    

    updateAvailabilityDays(selectedDayAvailability) {
        if (this.validateOverlappingAvailabilityDays(selectedDayAvailability)) {
            let updateAvailabilityDays;

            if (selectedDayAvailability.id === undefined || selectedDayAvailability.id === null || selectedDayAvailability.id === -1) {
                updateAvailabilityDays = this.props.availabilityDays.slice();
                selectedDayAvailability.id = updateAvailabilityDays.length + 1;
                updateAvailabilityDays.push(selectedDayAvailability);
            } else {
                updateAvailabilityDays = [];
                this.props.availabilityDays.map(day => {
                    if (day.id === selectedDayAvailability.id) {
                        updateAvailabilityDays.push(selectedDayAvailability);
                    } else {
                        updateAvailabilityDays.push(day);
                    }
                });
            }

            this.setState({
                ...this.state,
                currentDayAvailability: {
                    id: -1,
                    startHour: null,
                    startMinute: null,
                    endHour: null,
                    endMinute: null,
                    startDate: ''
                },
                isDaysChanged: true
            }, () => {
                this.props.updateAvailabilityDaysState(updateAvailabilityDays)
                document.getElementById("dayAvailabilityDate").value = '';
            });

        } else {
            this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.workTimeOverlaps'));
        
        return false;
        }
    }

    validateOverlappingAvailabilityDays(dayAvailability) {
        const { availabilityDays } = this.props;

        for (let i = 0; i < availabilityDays.length; i++) {
            const currentDayAvailability = availabilityDays[i];
            
            if((dayAvailability.startDate === currentDayAvailability.startDate) && !(dayAvailability.id === currentDayAvailability.id)) {
                
                // const moment = extendMoment(Moment);
                // let dayAvailabilityRange = moment.range(
                //     moment(`${dayAvailability.startHour}:${dayAvailability.startMinute}`, 'HH:mm'),
                //     moment(`${dayAvailability.endHour}:${dayAvailability.endMinute}`, 'HH:mm'));
                // let currentdayAvailabilityRange = moment.range(
                //     moment(`${currentDayAvailability.startHour}:${currentDayAvailability.startMinute}`, 'HH:mm'),
                //     moment(`${currentDayAvailability.endHour}:${currentDayAvailability.endMinute}`, 'HH:mm'));
    
                // if (dayAvailabilityRange.overlaps(currentdayAvailabilityRange) || dayAvailabilityRange.isSame(currentdayAvailabilityRange)) {
                //     return false;
                // }
                return false
            }
            
        }

        return true;
    }

    deleteCurrentDay(currentDay) {
        const updatedAvailabilityDays = [];

        this.props.availabilityDays.map(day => {
            if (currentDay.id !== day.id) {
                updatedAvailabilityDays.push(day);
            }
        });

        this.setState({
            isDaysChanged: true
        })

        this.props.updateAvailabilityDaysState(updatedAvailabilityDays)
    }

    editCurrentDay(currentDay) {
        this.setState({
            currentDayAvailability: {
                id: currentDay.id ? currentDay.id : null,
                startHour: currentDay.startHour,
                startMinute: currentDay.startMinute,
                endHour: currentDay.endHour,
                endMinute: currentDay.endMinute,
                startDate: currentDay.startDate
            }
        }, () => {
            document.getElementById("dayAvailabilityDate").value = moment(currentDay.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        })
    }

    renderWarningMessage() {
        if (this.state.isDaysChanged) {
            return (
                <p style={{ color: '#dc3545', fontSize: '80%', marginTop: 20, marginRight: 20 }}>{i18n.t('common:validations.saveWarningMsg')}</p>
            );
        }
    }

    renderTableRows() {

        const { availabilityDays } = this.props;
        
        return availabilityDays && availabilityDays.length > 0 ? availabilityDays.map((day, index) => {
            const prependTime = `${prependTimeWithZero(day.startHour)}:${prependTimeWithZero(day.startMinute)} -
            ${prependTimeWithZero(day.endHour)}:${prependTimeWithZero(day.endMinute)}`;
            return (
                <Col sm={12} key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgb(222, 226, 230)', paddingLeft: '0px'}}>
                    <Col sm={3}>{day.startDate}</Col>
                    <Col sm={3} style={{paddingLeft: '7px'}}>{prependTime}</Col>
                    <Col sm={6} style={{display: 'flex', justifyContent: 'end', paddingRight: '0px'}}>
                        <Button color="link" onClick={() => this.editCurrentDay(day)}>
                            <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={28} />
                        </Button>
                        <Button color="link" onClick={() => this.deleteCurrentDay(day)}>
                            <MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={28} />
                        </Button>
                    </Col>
                </Col>
            )
        }) : null
    }

    renderAddingDayTable() {
        const { startHour, startMinute, endHour, endMinute, startDate } = this.state.currentDayAvailability;
        let isDisabled = startHour === null || startMinute === null || endHour === null || endMinute === null || startDate === '';

        return (
            <Row style={{backgroundColor: 'rgba(204, 204, 204, 0.24)', paddingTop: '10px'}}>
                <Col xs={12} style={{paddingBottom: '15px'}}>
                    <FormGroup style={{ display: 'flex', marginBottom: '0px', flexDirection: 'column', width: '46%'}}>
                        <Label>{i18n.t('screens:productScreen.date')}</Label>
                        <Input 
                            id="dayAvailabilityDate"
                            type="date" 
                            name="startDate"
                            onChange={this.changeState}
                        />
                    </FormGroup>
                </Col>
                <Col xs={6}>
                    <Label>{i18n.t('screens:preparationTimes.from')}
                        <small style={{ color: 'rgb(169, 169, 169)', paddingLeft: '3px' }}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                    </Label>
                </Col>
                <Col xs={6}>
                    <Label>{i18n.t('screens:preparationTimes.to')}
                        <small style={{ color: 'rgb(169, 169, 169)', paddingLeft: '3px'}}>{i18n.t('screens:preparationTimes.timeFormat')}</small>
                    </Label>
                </Col>
                <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                    <AvGroup >
                        <AvInput type="number" id="startHour" name="startHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                            value={this.getValue(startHour)}
                            min={0} max={23}
                            onKeyPress={(e) => this.validateHoursValues(e)}
                            onChange={this.changeState}
                            required={false} />
                        <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                    </AvGroup>
                </Col>

                <div style={{ paddingTop: 10, color: 'rgb(169, 169, 169)' }}>:</div>

                <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                    <AvGroup >
                        <AvInput type="number" id="startMinute" name="startMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                            value={this.getValue(startMinute)}
                            min={0} max={59}
                            onKeyPress={(e) => this.validateMinutesValues(e)}
                            onChange={this.changeState}
                            required={false} />
                        <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                    </AvGroup>
                </Col>
                <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                    <AvGroup >
                        <AvInput type="number" id="endHour" name="endHour" placeholder={i18n.t('screens:preparationTimes.hoursAbbreviation')}
                            value={this.getValue(endHour)}
                            min={0} max={23}
                            onKeyPress={(e) => this.validateHoursValues(e)}
                            onChange={this.changeState}
                            required={false} />
                        <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                    </AvGroup>
                </Col>

                <div style={{ paddingTop: 10, color: 'rgb(169, 169, 169)' }}>:</div>

                <Col style={{ flex: '0 0 24.5%', maxWidth: '24.5%' }}>
                    <AvGroup>
                        <AvInput type="number" id="endMinute" name="endMinute" placeholder={i18n.t('screens:preparationTimes.minutesAbbreviation')}
                            value={this.getValue(endMinute)}
                            min={0} max={59} maxlength='2'
                            onKeyPress={(e) => this.validateMinutesValues(e)}
                            onChange={this.changeState}
                            required={false} />
                        <AvFeedback>{i18n.t('common:validations.invalid')}</AvFeedback>
                    </AvGroup>
                </Col>
                <Col xs={12} style={{display: 'flex', paddingRight: '20px', justifyContent: 'flex-end', marginTop: '12px', margin: '15px 0', alignItems: 'center' }}>
                    {this.renderWarningMessage()}
                    <Button
                        disabled={isDisabled} color="primary"
                        onClick={() => this.updateAvailabilityDays(this.state.currentDayAvailability)} >
                        <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                    </Button>
                </Col>
            </Row>
        )
    }

    renderDaysTable() {

        return (
            <Row sm={12} style={{padding: '20px 0px'}}>
                <Col sm={12} style={{backgroundColor: 'rgba(204, 204, 204, 0.24)', paddingLeft: '0px'}}>
                    <Col sm={6} style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '0px'}}>
                        <Col sm={6}>{i18n.t('screens:productScreen.date')}</Col>
                        <Col sm={6}>{i18n.t('screens:preparationTimes.fromTo')}</Col>
                    </Col>
                </Col>
                <Col sm={12} style={{padding: '0px', maxHeight: '140px', overflowY: 'scroll', overflowX: 'hidden'}}>
                    {this.renderTableRows()}
                </Col>
            </Row>
        )
    }

    render() {
        const { availabilitySettings, itemAvailableAllDay, readOnly } = this.props;
       
        return (
            <Fragment>
                {this.renderAddingDayTable()}
                {this.renderDaysTable()}
            </Fragment>
        );
    }
}

export default connect(null, { dispatchErrorMessage })(ProductDayAvailabilityScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/ProductDayAvailabilityScreen.js